import {
  getBreadcrumb,
  getItemList,
  getStructuredDataSchema,
  getWebpage,
  SEOItemListElementInput,
} from '@jusbrasil-web/shared-utils-seo'

export interface GetStructuredDataItemsProps {
  name: string
}

export interface GetStructuredDataProps {
  title: string
  labelTerm: string
  canonicalUrl: string
  items: GetStructuredDataItemsProps[]
}

export const getStructuredData = ({
  title,
  labelTerm,
  items,
  canonicalUrl,
}: GetStructuredDataProps) => {
  const url = canonicalUrl
  const description = `Julgados selecionados pelo Jus IA para a tese ${labelTerm}.`
  const itemListName = `Julgados pelo Jus IA sobre ${labelTerm} no Jusbrasil.`
  const itemListResults: SEOItemListElementInput[] = items.filter(Boolean).map((item) => ({
    docUrl: 'https://ia.jusbrasil.com.br/',
    title: item.name,
  }))

  return getStructuredDataSchema({
    webpage: getWebpage({
      description,
      canonicalUrl: url,
      name: title,
      image: { name: `Jusbrasil Fallback` },
      hasBreadcrumb: true,
      hasItemList: true,
    }),
    breadcrumb: getBreadcrumb({ name: labelTerm, canonicalUrl: url }),
    itemList: getItemList({
      name: itemListName,
      description,
      canonicalUrl: url,
      results: itemListResults,
    }),
  })
}
